import React from 'react';

type Props = {
  title: string;
  description?: string;
  action?: React.ReactNode;
};

export default function EmptyState({ title, description, action }: Props) {
  return (
    <div className="ui-empty-state" role="status">
      <p className="ui-empty-state__title">{title}</p>
      {description && <p className="ui-empty-state__desc">{description}</p>}
      {action && <div className="ui-empty-state__action">{action}</div>}
    </div>
  );
}
